export enum NftListingStatus {
  Created = 'created',
  Purchased = 'purchased',
}
